// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__21Ym5","small":"Spinner_small__28R_E","covering":"Spinner_covering__2kvrA","spinner":"Spinner_spinner__2Yv-5"};